import {TabFilters} from '../types/MyTeamsFilters.types';

export const buildClearedFilters = (
  filters: TabFilters,
): Partial<TabFilters> => {
  const resetOptions = (options: any[] = [], selectFirst = false) =>
    options.map((opt, index) => ({
      ...opt,
      selected: selectFirst ? index === 0 : false,
    }));

  return {
    rankOptions: resetOptions(filters.rankOptions),
    newCoachesOptions: resetOptions(filters.newCoachesOptions, true),
    fibcOptions: resetOptions(filters.fibcOptions, true),
    bonusOptions: resetOptions(filters.bonusOptions),

    rankWithoutFilter: undefined,
    newCoachesWithoutFilter: undefined,
    fibcWithoutFilter: undefined,
    fqvWithoutFilter: null,
    filterRangeWithoutFilter: null,
    newCoachesSponsoredWithoutFilter: null,
    bonusWithoutFilter: undefined,

    frontlineOnly: false,
    closeToNextRank: false,
    showAllFilters: false,
  };
};
